import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

import UniProfile from './Menu/UniProfile';
import { ShowCart } from './Menu/UniBasket';
import SearchDrawer from './HomeComp/SearchDrawer';
import { ControllNav } from './Functions/ControllNav';
import UniDrawer from './Menu/UniDrawer';
import { PostData } from './Functions/SendingData';
import SecondNavbar from './SecondNavbar';
import { baseText } from '../Lang/fa/BaseText';
import Dialog from '@material-ui/core/Dialog';
import userIcon from "../assets/SMSVG/userIcon.svg";
import basketIcon from "../assets/SMSVG/basketIcon.svg";
import arrow_search from '../assets/SMSVG/arrow-search.svg'
import SearchDrawerRes from './HomeComp/SearchDrawerRes';
import { LogoAnimation } from './LogoAnimation';

const Styles = styled.div`
  --nav-main-bg-blur: var(--gray-0);
  --nav-main-bg: var(--gray-0);
  --nav-logo: #051B75;
  --nav-text-1: var(--gray-5);
  --nav-text-2: var(--gray-6);
  --nav-bg-1: var(--light-bg);
  --nav-bg-2: var(--body-2);
  --nav-border: var(--gray-3);
  --nav-border-2: var(--gray-3);
  --nav-ham: var(--gray-6);
  &.dark-nav{
    --nav-main-bg-blur:var(--dark-nav);
    --nav-main-bg:#0A1020;
    --nav-logo: var(--gray-0);
    --nav-text-1: var(--gray-0);
    --nav-text-2: var(--gray-6);
    --nav-bg-1: var(--body-7);
    --nav-bg-2: var(--body-7);
    --nav-border: var(--gray-7);
    --nav-border-2: var(--gray-3);
    --nav-ham: var(--gray-6)
  }
  .top-ads {
    z-index: 902;
    height: 40px;
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    display: flex;
    justify-content: center;
    background-color: #1E1E1E;
    align-items: center;
    color: #FFFFFF;
    gap: 0.3rem;
    font-size: 0.85rem;
    font-weight: 500;
    white-space: nowrap;
    flex-wrap: wrap;
    .imp {
      cursor: pointer;
      font-weight: 700;
      border-bottom: 1px solid #fff;
    }
  }
  .main-navbar {
    z-index: 900;
    position: fixed;
    top: 0px;
    right: 0;
    left: 0;
    height: 60px;
    display: flex;
    justify-content: space-between;
    background: var(--nav-main-bg-blur);
    backdrop-filter: blur(15px);
    direction: rtl;
    padding: 0 var(--padding);
    width: calc(100vw - var(--width-padding));
    &.active {
      height: 60px;
      margin: 0;
      .center-logo {
        right: calc(50% - 70.5px);
        .svg {
          margin: 10px 5px ;
          height: calc(100% - 20px);
        }
      }
    }
  }
  .main-navbar .nav-container {
    height: 100%;
    display: flex;
    flex-grow: unset;
    gap: 1rem;
  }
  .main-navbar .center-logo {
    height: 100%;
    transition: all 0.1s ease-in-out;
  } 

  .main-navbar .nav-container .nav-link {
    cursor: pointer;
    position: relative;
    padding: 0 0.2rem 0;
    margin: 0;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-size: 1.5rem;
    color: var(--primary-1);
    .nav-icon {
      width: 32px;
      fill: var(--primary-1);
      border: 1px solid var(--nav-border);
      background: none;
      border-radius: var(--border-radius-2);
      padding: 8px;
    }
    .ham{
      transform: rotate(180deg);
    }
    .small-number {
      color: var(--text-3);
      cursor: pointer;
      position: absolute;
      text-align: center;
      min-width: 0.4rem;
      padding: 0.1rem 0.25rem 0rem;
      border-radius: 10rem;
      font-size: 0.6rem;
      font-weight: 800;
      top: 36px;
      right: calc(50% - 0.47rem);
      background-color: var(--secondry-1);
    }
  }
  .menu {
    svg {
      width: 2rem !important;
    }
    .menu-list {
      display: flex;
      flex-direction: column;
      width: 280px;
    }
  }
  .search {
    cursor: text;
    right: 32%;
    display: flex;
    font-size: 1.3em;
    flex-direction: row;
    position: absolute;
    top: 0.5rem;
    height: 40px;
    background-color: var(--nav-bg-1);
    border-radius: var(--border-radius-2);
    border: 1px solid var(--nav-border);
    width: 36vw;
    justify-content: center;
    align-items: center;
    .icon-close {
      transform: scale(1);
    }
    .search-container {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-end;
      width: 100%;
      background: var(--nav-bg-1);
    }
    .input {
      padding:  4px 40px 4px 0;
      flex-grow: 1;
      width: calc(100% - 40px);
      border: none;
      font-size: 1rem;
      height: calc(100% - 0.5rem);
      outline: none;
      color: var(--gray-6);
    }
    ::placeholder{
      color: var(--gray-5);
      font-weight:500
    }
    .icon {
      color: var(--gray-6) !important;
      width: 27px;
      height: 27px;
      padding: 0;
      height: calc(100% - 1rem);
      right: 0.5rem;
      top: 0.5rem;
      fill: var(--nav-text-2);
      position: absolute;
    }
    
    
    &.active {
    
    }
    @keyframes fade-in {
      100% {
        opacity: 1;
      }
      0%{
        opacity: 0;
      }
    }
  }    
  .main-navbar .nav-container .nav-link:hover {
    color: var(--primary-2);
    transform: scale(1.1);
  }
  @media screen and (max-width: 1000px) {
    .search {
      &.active {
        .input {
          width: 75vw;
        }
      }
    }
  }
  
  @media screen and (max-width:850px) {
    .main-navbar {
      .nav-container{ 
        margin: 0 ;
          .nav-link {
            padding: 0 ;
            font-size: 1.2em;
            .nav-icon {
              width: 28px;
            }
            .ham{
              fill: var(--nav-ham);
            }
        }
      }
      .menu{
        
      }
      .center-logo {
        .svg{
          margin: 15px 5px;
          height: calc(100% - 30px);
        }
      }
      &.active-search {
        height: 70px;
      }
    }
    
    .search {
      border: none;
      .search-container {
        border:1px solid var(--nav-border) ;
        border-radius: var(--border-radius-2);
        padding: 8px 0;
      }
    }
  }
 
`;
const DStyle = styled.div`
      width: calc(100% - 64%);
      overflow: hidden;
      position: fixed;
      inset: 45px 32% auto auto;
      z-index: 999;
      border-radius: var(--border-radius-2);
      background: var(--body-2);
      border: 1px solid var(--gray-3);
      .open{
        display: flex;
        cursor: pointer;
        display: flex;
        font-size: 1.3em;
        transition:fade-in all 0.3s ease-in-out;
        flex-direction: column;
        position: relative;
        width: 36vw;
        justify-content: center;
        background: var(--body-2);
        border-radius: var(--border-radius-2);
        border: 1px solid var(--gray-3);
        .icon-close {
          transform: scale(1);
        }

        .search-container {
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: flex-end;
          width: 100%;
          position: relative;
          height: 40px;
        }
        .input {
          padding:  4px 40px 4px 0;
          flex-grow: 1;
          width: calc(100% - 40px);
          border: none;
          font-size: 1rem;
          height: calc(100% - 0.5rem);
          outline: none;
          transition:fade-in all 0.3s ease-in-out;
          color: var(--gray-6);
        }
        ::placeholder{
          color: var(--gray-5);
          font-weight:500
        }
        .icon {
          color: var(--gray-6) !important;
          width: 1.8rem;
          height: 1.8rem;
          padding: 0;
          height: calc(100% - 1rem);
          right: 0.5rem;
          top: 0.5rem;
          transition:fade-in all 0.3s ease-in-out;
          fill: var(--gray-6);
          position: absolute;
        }
      }
      @media screen and (max-width : 850px){
        inset: 0 0 auto auto;
        width:100%;
        border: none;
        .open{
          width: 95%;
          margin: 1rem 0.5rem 0;
          background: var(--body-2);
          padding: 0;
          
          .input{
            width: 80%;
            background: var(--body-2);
          }
          .icon{
            width: 1.5rem;
            height: 1.5rem;
            top: 0.5rem;
          }
        }
        .boxshadow{
          box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.08);
          width: 100%;
          height: 1rem;
        }
      }
`
const OutStyle = styled.div`
  --nav-bg-2: var(--body-2);
  --nav-bg-1: var(--light-bg);
  --nav-border: var(--gray-3);
  
  &.dark-nav{
    --nav-bg-2: var(--body-7);
    --nav-bg-1: var(--body-7);
    --nav-border: var(--gray-7);
  }
  width: 10rem;
  border: 1px solid var(--nav-border);
  border-radius: var(--border-radius-2);
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  padding: 10px;
  height: calc(70% - 20px);
  margin-top: 0.5rem;
  cursor: pointer;
  .login-text{
    font-size: 1rem;
    font-weight: 600;
    color: var(--gray-6);
  }
  @media screen and (max-width:850px) {
    width: 1.5rem;
  }
`
class NavBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ShowProfile: false,
      navActive: false,
      activeSearch: false,
      keyword: '',
      Drawer: false,
      menus: [],
      loadingMenus: true,
      able:false,
      drawerDown:false,
      width : (window.innerWidth > 850)
    };
  }
  componentDidMount() {
    this._ismounted = true;
    this.getMenuData()
  }

  componentWillUnmount() {
    this._ismounted = false;
    document.removeEventListener('scroll', this.TopActive);
  }

  // get data for menus cache
  getMenuData() {
    let menus = localStorage.getItem('lux-menus');
    let now = parseInt(Date.now() / 1000);
    let menusTime = localStorage.getItem('lux-menus-time');
    if(menus && now - menusTime < 3600){
      this.setState({
        loadingMenus: false,
        menus: JSON.parse(menus),
      });
    } else {
      this.setState({
        loadingMenus: true,
      });
      let formData = new FormData();
      formData.append('api_token', localStorage.getItem('token'));
      formData.append('G_GR_CONTROL',1);
      PostData(
        process.env.REACT_APP_API + '/api/v1/goods/g_group/group_menu',
        formData,
        this,
        this.ProccessMenu
      );
    }
  }
  ProccessMenu(obj, response) {
    response = JSON.parse(response);
    
    if (response.status === 'success') {
      obj.setState({
        loadingMenus: false,
        menus: response.data,
      });
      localStorage.setItem('lux-menus', JSON.stringify(response.data));
      localStorage.setItem('lux-menus-time', parseInt(Date.now() / 1000));
      
    } else if (response.status === 'error') {
      obj.setState({
        loadingMenus: false,
        menus: [],
      });
    } else if (response.status === 'error-no-internet') {
      obj.setState({
        loadingMenus: false,
        menus: [],
      });
    }
  }

  TopActive = (e) => {
    if (window.scrollY !== 0) {
      if(this.state.navActive === false){
        this.setState({
          navActive: true,
        });
      }
      
    } else {
      this.setState({
        navActive: false,
      });
    }
  };

  showprofile = () => {
    if (this._ismounted) {
      if (this.state.ShowProfile) {
        this.setState({
          ShowProfile: false,
        });
      } else {
        this.setState({
          ShowProfile: true,
        });
      }
    }
  };
  closeprofile = () => {
    if (this._ismounted) {
      this.setState({
        ShowProfile: false,
        ShowCart: false,
      });
    } else {
      this.setState({
        ShowProfile: false,
        ShowCart: false,
      });
    }
  };

  getAllCount = () => {
    if (this.props.loading) {
      let cart = this.props.cart;
      let count = 0;
      cart.forEach((value) => {
        value.SHOP_BASKET.forEach((v) => {
          count += v.TEMP_BASK_COUNT;
        })
      });
      return count;
    } else {
      return '-';
    }
  };

  OpenSearch = () => {
    if (this.state.activeSearch) {
      this.setState({
        activeSearch: false,
      });
    } else {
      this.setState({
        activeSearch: true,
      });
      document.getElementById('main-search').focus();
    }
  };
  searchAble=()=>{
    this.setState({
      able: true,
      searchOpen:true
    })
    window.setTimeout(function() {
      document.getElementById('main-search').focus();
    }, 0);
  }
  
  getSearch = () => {
    return (
      <div className='search ' onClick={this.searchAble}>
        <div className="search-container">
          <svg className="icon" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M22.0413 20.156L27.752 25.8653L25.8653 27.752L20.156 22.0413C18.0316 23.7443 15.3893 24.6705 12.6666 24.6667C6.04263 24.6667 0.666626 19.2907 0.666626 12.6667C0.666626 6.04266 6.04263 0.666656 12.6666 0.666656C19.2906 0.666656 24.6666 6.04266 24.6666 12.6667C24.6705 15.3893 23.7443 18.0316 22.0413 20.156ZM19.3666 19.1667C21.0588 17.4265 22.0038 15.0939 22 12.6667C22 7.50932 17.8226 3.33332 12.6666 3.33332C7.50929 3.33332 3.33329 7.50932 3.33329 12.6667C3.33329 17.8227 7.50929 22 12.6666 22C15.0939 22.0038 17.4265 21.0588 19.1666 19.3667L19.3666 19.1667Z" fill="#979797"/>
          </svg>
          <div
            className='input'
            onClick={this.searchAble}
          >
            {baseText.search}
          </div>
        </div>
      </div>
    );
  };
  Searched = (e) => {
    // if (e.target.value.length > 1) {
    //   this.setState({
    //     searchOpen: true,
    //   });
    // } else {
    //   if (this.state.searchOpen === true) {
    //     this.setState({
    //       searchOpen: false,
    //     });
    //   }
    // }
    this.setState({
      keyword: e.target.value,
    });
  };
  ClearSearch = () => {
    if (this.state.searchOpen === true) {
      this.setState({
        keyword: '',
        searchOpen: false,
        activeSearch: false,
      });
    } else {
      this.setState({
        keyword: '',
        activeSearch: false,
      });
    }
  };
  showResult=()=>{
    return(
      <DStyle>
        <div className='search open '>
          <div className="search-container">
            {
               this.state.width ?(
                <svg className="icon" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M22.0413 20.156L27.752 25.8653L25.8653 27.752L20.156 22.0413C18.0316 23.7443 15.3893 24.6705 12.6666 24.6667C6.04263 24.6667 0.666626 19.2907 0.666626 12.6667C0.666626 6.04266 6.04263 0.666656 12.6666 0.666656C19.2906 0.666656 24.6666 6.04266 24.6666 12.6667C24.6705 15.3893 23.7443 18.0316 22.0413 20.156ZM19.3666 19.1667C21.0588 17.4265 22.0038 15.0939 22 12.6667C22 7.50932 17.8226 3.33332 12.6666 3.33332C7.50929 3.33332 3.33329 7.50932 3.33329 12.6667C3.33329 17.8227 7.50929 22 12.6666 22C15.0939 22.0038 17.4265 21.0588 19.1666 19.3667L19.3666 19.1667Z" fill="#979797"/>
                </svg>
               ):(
                <img src={arrow_search} className='icon' alt='result' onClick={this.ClearSearch} />
              )
            }
            <input
              className='input'
              type='text'
              id="main-search"
              placeholder={baseText.search}
              value={this.state.keyword}
              onChange={this.Searched}
            />
          </div>
        </div>
        {this.state.width ? ' ' : <div className='boxshadow'></div>}
        <SearchDrawerRes
          open={this.state.searchOpen}
          keyword={this.state.keyword}
          clearSearch={this.ClearSearch}
          {...this.props}
          />
      </DStyle>
    )
  }
  basketShow=()=>{
    return(
      <div className="nav-link no-click-cart" onClick={ShowCart}>
        <img className='nav-icon' src={basketIcon} alt='سبد خرید'/>
        <div className="small-number">{this.getAllCount()}</div>
      </div>
    )
    // return(
    //   <div className="nav-link no-click-cart" onClick={(this.props.userdata) ? ShowCart : this.showprofile }>
    //     <img className='nav-icon' src={basketIcon} alt='سبد خرید'/>
    //     <div className="small-number">{this.getAllCount()}</div>
    //   </div>
    // )
  }
  userShow=(home)=>{
    if (this.props.userdata) {
      return(
        <div className="nav-container" >
         
          <div className="nav-link no-click" onClick={this.showprofile} >
            <img className='nav-icon' src={userIcon} alt='پروفایل' style={{background: (this.state.ShowProfile) ? 'var(--body-2)' : ''}}/>
            {
              (this.props.notif && this.props.notif !== 0) ? 
                <div className="small-number">{this.props.notif}</div>
                :''
            }
          </div>
          {
            this.state.width ? (
              this.basketShow()
            ):
            ''
          }
        </div>
      )
    }else{
      return(
        <div className="nav-container" >
         
          <div className="nav-link no-click" onClick={this.props.setOpen} >
            <img className='nav-icon' src={userIcon} alt='پروفایل' style={{background: (this.state.ShowProfile) ? 'var(--body-2)' : ''}}/>
            {
              (this.props.notif && this.props.notif !== 0) ? 
                <div className="small-number">{this.props.notif}</div>
                :''
            }
          </div>
          {
            this.state.width ? (
              this.basketShow()
            ):
            ''
          }
        </div>
      )
      // return(
      //   <OutStyle onClick={this.props.setOpen} className={home ? ' dark-nav':''}>
      //     <img className='nav-icon' src={userIcon} alt='سبد خرید'/>
      //     {this.state.width ? <span className='login-text'>ورود/ثبت نام</span> : ''}
      //   </OutStyle>
      // )
    }
  }
  displaySearch=()=>{
    if(!this.state.width ){
      return(
        <Dialog
            fullScreen={true}
            open={this.state.searchOpen}
            onClose={this.ClearSearch}
            BackdropProps={{
              style:{
                background:'transparent',
              }
            }}
        >
          {this.showResult()}
        </Dialog>
      )
    }else{
      return(
        <Dialog
            fullWidth={true}
            maxWidth={'sm'}
            open={this.state.searchOpen}
            onClose={this.ClearSearch}
            BackdropProps={{
              style:{
                background:'transparent',
              }
            }}
            
        >
          {this.showResult()}
        </Dialog>
      )
    } 
   }
  render() {
    if(this.props.location.pathname !== "/" && !ControllNav(this.props.location.pathname)){
      return "";
    }
    document.addEventListener('scroll', this.TopActive);
    let disableLogo = {};
    let desableIcons = {};
    let home = ( this.props.location.pathname === '/aboutus'  || this.props.location.pathname === '/contactus' )
    let searchHide = new URLSearchParams(document.location.search).get('page')
    let campaign = ( parseInt(searchHide) !== 5  && this.props.location.pathname.split('/')[1]==='campaign')

    if (this.state.activeSearch) {
      disableLogo = {
        display: 'none',
      };
      desableIcons = {
        display: 'none',
      };
    }
    return (
      <Styles className={(home || campaign) ? 'dark-nav' : '' }>
        {/* <div className='top-ads'>
          ۱۰۰ هزار تومان اعتبار هدیه برای کاربران جدید <span className='imp' onClick={this.props.setOpen}>همین حالا ثبت نام کنید</span>
        </div> */}
        {this.state.searchOpen ?
          <div className= 'backdark'></div>
          :''
        }
        <div className={'main-navbar '+ ((this.state.activeSearch) ? " active-search" : "")}>
            {
              !this.state.width  ? (
                <div className="nav-container" >
                      <UniDrawer {...this.props} menus={this.state.loadingMenus ? [] : this.state.menus} activeSearch={this.state.activeSearch}/>
                </div>
              ) : (
                ''
              )
            }

          <div className="center-logo" style={disableLogo}>
            <Link to="/">
              <LogoAnimation active={this.state.navActive}/>
            </Link>
          </div>

          {
            this.state.width ? (
              <div className="nav-container" >
                {this.getSearch()}
              </div>
            )
            :''
          }
          {this.userShow(home)}
        </div>
        <UniProfile
          state={this.state.ShowProfile}
          func={this.closeprofile}
          {...this.props}
        />
        {this.displaySearch()}
        <SecondNavbar 
          {...this.props} 
          menus={this.state.loadingMenus ? [] : this.state.menus} 
          activeSearch={this.state.activeSearch}
          basketShow={this.basketShow}
          getSearch={this.getSearch}/>
      </Styles>
    );
  }
}
export default NavBar;
